package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_03_07_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes in the sea of indifference between Freeburg and Kostigan. They have just defeated a late-night boarding party of demons and Merrow — the demons have turned into black goo, but the Merrow’s corpses lie on the deck. The heroes explain Lord Verdus Pent and his demonic pact to Captain Leah L’Seth. Annette shares an old story she heard that the Merrow fell under a demonic influence long ago, which twisted them — and they have been vessels of demons ever since. Captain Leah instructs the crew to throw the Merrow bodies into the sea. The heroes return to bed.")
    }
}
